import logo from "./logo.svg";
import "./App.css";
import Home from "./Pages/Home";
import StartPage from "./Pages/StartPage";
import PaymentPage from "./Pages/PaymentPage";
import ThankPage from "./Pages/ThankPage";
import {
  BrowserRouter as Router,
  Form,
  Route,
  Routes,
  useParams,
} from "react-router-dom";

import axios from "axios";
import NotFound from "./Pages/NotFound";
import { useDispatch, useSelector } from "react-redux";
import {
  PlanNameAction,
  sessionRed,
  sessionTrial,
  setSessionsLoading,
} from "./Component/Redux/Feature/UrlSlice";
import Loading from "./Pages/Loading";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { apiUrl } from "./Utils/constants";
import TermsConditionPage from "./Pages/TermsConditionPage";
import FaviconChanger from "./Utils/favIcon";
import CategorySelect from "./Modules/CategorySelect";
import BranchSelect from "./Modules/BranchSelect";
import { SET_BRANCH, SET_CATEGORY, SET_TRIAL } from "./Component/Redux/Feature/CategorySlice";

function App() {
  const [sessions, setSessions] = useState([]); //store all reformer pilates sessions
  const [userPlan, setUserPlan] = useState();

  const dispatch = useDispatch();

  const { trialVal } = useSelector((state) => state.Categories);
  const { emailStored, appStatus } = useSelector((state) => state.emailData);

  const queryAppParams = new URLSearchParams(window.location.search);
  const appParam = queryAppParams.get("app") === "true" || appStatus;

  const trialParam = queryAppParams.get("trial");

  const navigate = useNavigate();
  const location = window.location.pathname.split("/")[3];

  const [dummyState, setDummyState] = useState(false);

  const location2 = window.location;

  // const { planname } = useParams();

  const [planname, setPlanName] = useState(null);

  useEffect(() => {
    // dispatch(SET_TRIAL(null));

    // dispatch(sessionTrial([]))
    // dispatch(sessionRed([]))

    if (queryAppParams.get("trial")) {
      dispatch(SET_TRIAL(queryAppParams.get("trial")));
    }

    const locationSplit = location2.pathname.split("/");

    if (locationSplit.length == 4) {         
        setPlanName(locationSplit[3]);         
        dispatch(SET_CATEGORY(locationSplit[1]));
        dispatch(SET_BRANCH(locationSplit[2]));
    }

    if (locationSplit.length == 3) {               
      dispatch(SET_BRANCH(locationSplit[2]));
      dispatch(SET_CATEGORY(locationSplit[1]));
    }

    if (locationSplit.length == 2) {               
      dispatch(SET_CATEGORY(locationSplit[1]));      
    }
  }, [location2.pathname, queryAppParams, dispatch]);


  // useEffect(() => {
  //   const locate = encodeURIComponent(location);
  //   axios({
  //     method: "get",
  //     url: apiUrl + "/getSessions?plan=" + locate,
  //     // url: apiUrl+"/getSessions?plan=Reformer-Pilates", //Calling hardcoded plan for now

  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((response) => {
  //       let isTrial = [];
  //       let noTrial = [];
  //       response.data.data.map((sess) => {
  //         if (sess.not_toweb !== 0 && appParam !== "true") {
  //           if (sess.istrial) {
  //             isTrial.push(sess);
  //           } else {
  //             noTrial.push(sess);
  //           }
  //         } else if (sess.not_toapp !== 0 && appParam === "true") {
  //           if (sess.istrial) {
  //             isTrial.push(sess);
  //           } else {
  //             noTrial.push(sess);
  //           }
  //         }
  //       });
  //       // && sess.not_toweb !== 0
  //       dispatch(sessionRed(noTrial));
  //       dispatch(sessionTrial(isTrial));
  //       // dispatch(sessionRed(response.data.data));
  //       dispatch(PlanNameAction(location));
  //       document.title = response.data.data[0].planname + " Payment Checkout";
  //     })
  //     .catch((error) => {
  //       navigate("/NotFound");
  //     });
  // }, []);

  useEffect(() => {
    console.log("PLANNAME effect ran");

    const locationSplit = location2.pathname.split("/");
    let planname;

    if (locationSplit.length == 4) {
      planname = locationSplit[3];
    }
    
    if (planname) {
      // const locate = encodeURIComponent(location);
      console.log("useEffect ran");
      console.log("planname => ", planname);
      dispatch(sessionRed([]));
      dispatch(sessionTrial([]));
      dispatch(setSessionsLoading(true));

      axios({
        method: "get",
        url: apiUrl + "/getSessions?plan=" + encodeURIComponent(planname),
        // url: apiUrl+"/getSessions?plan=Reformer-Pilates", //Calling hardcoded plan for now

        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          let isTrial = [];
          let noTrial = [];
          console.log("plan session response ", response.data);
          console.log(appParam);
          response?.data?.data.map((sess) => {
            console.log("inside map");


            if(sess.not_toweb !== 0 && !appParam){
              if (sess.istrial){
              isTrial.push(sess)
          
              }else{
              noTrial.push(sess)
              }
            }else if(sess.not_toapp !== 0 && appParam){
              if (sess.istrial){
                isTrial.push(sess)
                }
                else{
                noTrial.push(sess)
               }
            }

            // if(sess.not_toweb == 1 && !appParam) {
            //   if (sess.istrial){
            //     isTrial.push(sess)
            //     }else{
            //     noTrial.push(sess)
            //     }
            // }
            // else if(sess.not_toapp == 1 && appParam) {

            // }

            // if(appParam ) {
            //   if(sess.not_toweb != 0) {
            //     if (sess.istrial){
            //       isTrial.push(sess)
            //       }
            //       else{
            //       noTrial.push(sess)
            //      }
            //   }
            // }


            // if (sess?.not_toweb !== 1) {
            //   if (sess?.istrial) {
            //     isTrial.push(sess);
            //   } else {
            //     noTrial.push(sess);
            //   }
            // } else if (sess?.not_toapp !== 0) {
            //   if (sess?.istrial) {
            //     isTrial.push(sess);
            //   } else {
            //     noTrial.push(sess);
            //   }
            // }
          });

          // if (trialVal === "default") {
          //   dispatch(sessionRed(noTrial));
          //   dispatch(sessionTrial(isTrial));
          // } else {
          // && sess.not_toweb !== 0

          console.log("no trial", noTrial);
          if (trialVal == "false" && emailStored) {
            dispatch(sessionRed(noTrial));
            dispatch(sessionTrial([]));
          } else if (trialVal == "true" && !emailStored) {
            dispatch(sessionTrial(isTrial));
            dispatch(sessionRed([]));
          } else if (trialVal == "true" && emailStored) {
            dispatch(sessionTrial(isTrial));
            dispatch(sessionRed([]));
          } else if (trialVal == "false" && !emailStored) {
            dispatch(sessionTrial([]));
            dispatch(sessionRed(noTrial));
          } 
          else if(trialVal == "default")
          {           
            dispatch(sessionRed(noTrial));
            dispatch(sessionTrial(isTrial));
          }
          else {
            dispatch(sessionRed(noTrial));
            dispatch(sessionTrial(isTrial));
          }          

          // }
          // dispatch(sessionRed(response.data.data));

          dispatch(PlanNameAction(location));
          document.title = response.data.data[0].planname + " Payment Checkout";
          dispatch(setSessionsLoading(false));

          if(response?.data?.status != "success" && response?.data?.error == true)
          {
            navigate("/NotFound");
          }
          
        })
        .catch((error) => {
          dispatch(setSessionsLoading(false));
          console.log("Error => ", error);
          navigate("/NotFound");
        });
    }
  }, [planname, dispatch, queryAppParams]);

  return (
    <>
      <FaviconChanger />
      <Routes>
        {/* <Route path="/plans" element={<Loading />} />
              <Route path="/:name" element={<StartPage />} />
         </Route> */}
        <Route path="/" element={<Loading />}>
          {/* <Route path=":planname" element={<Home />} />
          <Route path=":planname/form" element={<StartPage />} />
          
          <Route
            path=":planname/confirmation"
            element={<TermsConditionPage />}
          />

          <Route path=":planname/payment" element={<PaymentPage />} />
          <Route path=":planname/thank" element={<ThankPage />} />
          <Route path=":planname/*" element={<NotFound />} /> */}

          <Route path="/" element={<CategorySelect />} />

          <Route path="/:category" element={<BranchSelect />} />

          <Route path="/:category/:branch/:planname" element={<Home />} />

          {/* <Route
            path="/:category/:branch/:planname"
            element={<div>test {planname && console.log(planname)}</div>}
          /> */}

          <Route
            path="/:category/:branch/:planname/form"
            element={<StartPage />}
          />

          <Route
            path="/:category/:branch/:planname/confirmation"
            element={<TermsConditionPage />}
          />

          <Route
            path="/:category/:branch/:planname/payment"
            element={<PaymentPage />}
          />

          <Route
            path="/:category/:branch/:planname/thank"
            element={<ThankPage />}
          />

          <Route path="/:category/:branch/:planname/*" element={<NotFound />} />

          <Route path="/NotFound" element={<NotFound />} />
        </Route>

        {/* <Route path="/404-NotFound" element={<NotFound />} /> */}
        {/* {planName && <Route path="/form" element={<StartPage />} />}
          {planName && <Route path="/payment" element={<PaymentPage />} />}
          {planName & <Route path="/thank" element={<ThankPage />} />} */}
      </Routes>
    </>
  );
}

export default App;
